<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
        <i class="material-icons">search</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="openMenu()">
        <i class="material-icons">more_vert</i>
      </div>
    </div>
    <div class="ir-line-content">
      <span
        >{{ 'people.people-list' | translate }} <strong>({{ people?.length }})</strong></span
      >
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="query"
        focus="showSearch"
      />
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <div class="ir-section--list th-section--admin">
    <div class="ir-line ir-line-title">
      <div class="ir-line--right">
        <div style="display: inline-block; padding-right: 10px">
          <button class="ir-btn ir-btn--block ir-btn--title th-btn-action ir-txt--right" (click)="addPerson()">
            <span>{{ 'people.add-person' | translate }}</span>
          </button>
        </div>
        <div style="display: inline-block">
          <button
            [disabled]="(selectedUsers$ | async).length < 2"
            class="ir-btn ir-btn--block ir-txt--right"
            [ngClass]="(selectedUsers$ | async).length >= 2 ? 'th-btn-action ir-btn--title' : 'ir-btn--disabled'"
            (click)="editPeople()"
          >
            <span>{{ 'people.edit-selected' | translate }}</span>
          </button>
        </div>
      </div>
      <div class="ir-line-content">
        <span>{{ 'people.inspection-planification' | translate }}</span>
      </div>
    </div>
    <people-list-table [people]="people" (toggleSelectPerson)="openPerson($event)" [query]="query"></people-list-table>
  </div>
</div>
<modal (modalOutput)="selectMenu($event)"></modal>
